import { styled } from '@mui/material/styles';
import { Image } from 'core/common/ui/ui-kit';
import Icon from 'core/svg-sprites/ui/Icon';

export const GuaranteeIconStyled = styled(Icon)`
  fill: ${({ theme }) => theme.palette.success.main};
`;

export const BrandsImageStyled = styled(Image)`
  display: block;
  width: 75%;
  margin-right: auto;
  margin-left: auto;
`;
